
import Calendar from './modules/index';

export default Calendar


// WEBPACK FOOTER //
// ./src/index.js